// extracted by mini-css-extract-plugin
module.exports = {"comp":"JC_comp____3Ce"};